// extracted by mini-css-extract-plugin
export var cmtNavItem = "styles-module--cmt-nav-item--fa9db";
export var cmtNavItemModeDark = "styles-module--cmt-nav-item--mode-dark--8f74d";
export var cmtNavItem__container = "styles-module--cmt-nav-item__container--bf5ca";
export var cmtNavItem__text = "styles-module--cmt-nav-item__text--bbc94";